import block_icons from '../icons/heading';
import color_palette_list from '../gb-helper/color_palette';
import { all_font_families } from '../gb-helper/font_family_detailed';

const { registerBlockType } = wp.blocks;
const { __ } = wp.i18n;
const { InspectorControls, RichText } = wp.blockEditor;
const { PanelBody, PanelRow, SelectControl, Dashicon, Card, CardBody, Button, TextareaControl, TextControl, CheckboxControl,
    RangeControl, ColorIndicator, ColorPalette } = wp.components;

registerBlockType('blocksbakery/heading', {
    title: __('Heading', 'blocks-bakery'),
    description: __(
        'heading allows you to use attractive and trendy headings in combination with subheadings and a separator between them. You are able to choose the heading tags with the manual settings and customization.',
        'blocks-bakery'
    ),
    // common, formatting, layout, widgets, embed
    category: 'blocks-bakery',
    icon: block_icons.heading,
    keywords: [
        __('Advance', 'blocks-bakery'),
        __('Heading', 'blocks-bakery'),
        __('Simple Heading', 'blocks-bakery')
    ],
    supports: {
        html: false,
    },
    "attributes": {
        "content_heading": {
            "type": "string"
        },
        "title_link": {
            "type": "string"
        },
        "open_tab_option": {
            "type": "boolean",
            "default": false
        },
        "open_tab": {
            "type": "string",
            "default": null
        },
        "nofollow": {
            "type": "boolean",
            "default": false
        },
        "rel_nofollow": {
            "type": "string",
            "default": null
        },
        "title_color": {
            "type": "string",
            "default": "#000000"
        },
        "title_opacity": {
            "type": "string",
            "default": "FF"
        },
        "title_family": {
            "type": "string",
            "default": "Arial"
        },
        "title_weight": {
            "type": "string",
            "default": "regular"
        },
        "text_transform": {
            "type": "html",
            "default": "none",
        },
        "text_decoration": {
            "type": "string",
            "default": "none",
        },
        "title_height": {
            "type": "number",
            "default": 1.5,
        },
        "title_size": {
            "type": "number",
        },
        "pxfortile": {
            "type": "string",
            "default": "px"
        },
        "blend_mode": {
            "type": "string",
            "default": "normal"
        },
        "heading_style": {
            "source": "attribute",
            "attribute": "style"
        },
        "lineheightpxemfortitle": {
            "type": "string",
            "default": "em"
        },
        "letter_spacing_title": {
            "type": "number"
        },
        "text_shadow_horizental": {
            "type": "number",
            "default":0
        },
        "text_shadow_vertical": {
            "type": "number",
            "default":0
        },
        "text_shadow_clor": {
            "type": "string"
        },
        "title_shadow_blur": {
            "type": "number",
            "default": 10
        },
        "heading": {
            "type": "string",
            "default": "h2"
        },
        "text_shadow_clors": {
            "type": "string",
            "default": "#000000"
        },
        "title_align": {
            "type": "string",
            "default": "left"
        },
        "font_style": {
            "type": "string",
            "default": "inherit"
        },
        "font_range_controller": {
            "type": "number",
            "default": 200
        },
        "line_range_controller": {
            "type": "number",
            "default": 100
        }

    },

    edit: (props) => {
        const hexConverter = (val) => {
            val = Math.round(val * 100) / 100;
            var alpha = Math.round(val * 255);
            var hex = (alpha + 0x10000).toString(16).substr(-2).toUpperCase();
            props.setAttributes({ title_opacity: hex })
        }

        const px_case = () => {
            var px_case = document.getElementById("px_case");
            var em_case = document.getElementById("em_case");
            var rem_case = document.getElementById("rem_case");
            var vw_case = document.getElementById("vw_case");
            px_case.style.textDecoration = "underline";
            em_case.style.textDecoration = "none";
            rem_case.style.textDecoration = "none";
            vw_case.style.textDecoration = "none";

            props.setAttributes({ pxfortile: 'px', font_range_controller: 200 })
            console.log("px")
        }
        const em_case = () => {
            var px_case = document.getElementById("px_case");
            var em_case = document.getElementById("em_case");
            var rem_case = document.getElementById("rem_case");
            var vw_case = document.getElementById("vw_case");
            px_case.style.textDecoration = "none";
            em_case.style.textDecoration = "underline";
            rem_case.style.textDecoration = "none";
            vw_case.style.textDecoration = "none";

            props.setAttributes({ pxfortile: 'em', font_range_controller: 10 })
            console.log("em")
        }
        const rem_case = () => {
            var px_case = document.getElementById("px_case");
            var em_case = document.getElementById("em_case");
            var rem_case = document.getElementById("rem_case");
            var vw_case = document.getElementById("vw_case");
            px_case.style.textDecoration = "none";
            em_case.style.textDecoration = "none";
            rem_case.style.textDecoration = "underline";
            vw_case.style.textDecoration = "none";

            props.setAttributes({ pxfortile: 'rem', font_range_controller: 10 })
        }
        const vw_case = () => {
            var px_case = document.getElementById("px_case");
            var em_case = document.getElementById("em_case");
            var rem_case = document.getElementById("rem_case");
            var vw_case = document.getElementById("vw_case");
            px_case.style.textDecoration = "none";
            em_case.style.textDecoration = "none";
            rem_case.style.textDecoration = "none";
            vw_case.style.textDecoration = "underline";

            props.setAttributes({ pxfortile: 'vw', font_range_controller: 10 })
        }

        const title_px_lineh = () => {
            var x = document.getElementById("title_px_lineh");
            var y = document.getElementById("title_em_lineh");
            x.style.textDecoration = "underline";
            y.style.textDecoration = "none";
            props.setAttributes({ lineheightpxemfortitle: 'px', line_range_controller: 100 })

        }

        const title_em_lineh = () => {
            var x = document.getElementById("title_px_lineh");
            var y = document.getElementById("title_em_lineh");
            x.style.textDecoration = "none";
            y.style.textDecoration = "underline";
            props.setAttributes({ lineheightpxemfortitle: 'em', line_range_controller: 10 })

        }

        const title_reset = () => {
            props.setAttributes({ text_shadow_horizental: 0 })
            props.setAttributes({ text_shadow_vertical: 0 })
            props.setAttributes({ text_shadow_clor: '' })
            props.setAttributes({ title_shadow_blur: 0 })
        }


        const title_toggle = (new_val) => {
            var x = document.getElementById("prifex-toggle");
            if (x.style.display === "block") {
                x.style.display = "none"
                props.setAttributes({text_shadow_clor:"",title_shadow_blur:0})
            }
            else if (x.style.display === "none") {
                x.style.display = "block";
                props.setAttributes({text_shadow_clor:"#000000",title_shadow_blur:10})
            }
        }

        const alignCenter = () => {
            props.setAttributes({ title_align: 'center' })
        }
        const alignLeft = () => {
            props.setAttributes({ title_align: 'left' })
        }
        const alignRight = () => {
            props.setAttributes({ title_align: 'right' })
        }
        const alignJustify = () => {
            props.setAttributes({ title_align: 'justify' })
        }
        const clearTitleColor = () => {
            props.setAttributes({ title_color: '#000000' })
        }
        const clearTitleShadowColor = () => {
            props.setAttributes({ title_color: 'transparent' })
        }
        const laptop = () => {
            wp.data.dispatch('core/edit-post').__experimentalSetPreviewDeviceType('Device');
        }
        const tablet = () => {
            wp.data.dispatch('core/edit-post').__experimentalSetPreviewDeviceType('Tablet');
        }
        const smartphone = () => {
            wp.data.dispatch('core/edit-post').__experimentalSetPreviewDeviceType('Mobile');
        }


        // let atts = props.attributes;
        const setAttributes = props.setAttributes;
        let styles = {
            heading_container:{
                textAlign:props.attributes.title_align
            },
            heading_link:{
                textDecoration:'none'
            },
            title_link: {
                textDecoration: props.attributes.text_decoration,
                color: props.attributes.title_color + props.attributes.title_opacity,
                fontFamily: props.attributes.title_family,
                fontWeight: props.attributes.title_weight,
                fontSize: props.attributes.title_size + props.attributes.pxfortile,
                textTransform: props.attributes.text_transform,
                lineHeight: props.attributes.title_height + props.attributes.lineheightpxemfortitle,
                letterSpacing: props.attributes.letter_spacing_title,
                textShadow: props.attributes.text_shadow_horizental + 'px ' + props.attributes.text_shadow_vertical + 'px ' + props.attributes.title_shadow_blur + 'px ' + props.attributes.text_shadow_clor,
                mixBlendMode: props.attributes.blend_mode,
                textAlign: props.attributes.title_align,
                fontStyle: props.attributes.font_style
            },
        }

        return (
            <React.Fragment>
                <InspectorControls>
                    <PanelBody title={__('Advanced Heading', 'blocks-bakery')} initialOpen={false}>
                        <TextareaControl
                            label="Title"
                            placeholder="Add Your Heading Text Here"
                            value={props.attributes.content_heading}
                            onChange={(value) => props.setAttributes({ content_heading: value })}
                        />
                        <hr />
                        <TextControl
                            label="Link"
                            value={props.attributes.title_link}
                            onChange={(value) => props.setAttributes({ title_link: value })}
                        />
                        <CheckboxControl
                            label="open in new window"
                            checked={props.attributes.open_tab_option}
                            onChange={(value) => {
                                if (value === false) {
                                    props.setAttributes({ open_tab: "_self", open_tab_option: false })
                                } else {
                                    props.setAttributes({ open_tab: "_blank", open_tab_option: true })
                                }
                            }
                            }
                        />
                        <CheckboxControl
                            label="Add nofollow"
                            checked={props.attributes.nofollow}
                            onChange={(value) => {
                                if (value === false) {
                                    props.setAttributes({ rel_nofollow: null, nofollow: false })
                                } else {
                                    props.setAttributes({ rel_nofollow: "nofollow", nofollow: true })
                                }
                            }
                            }
                        />
                        <SelectControl
                            label={__("Font Size", "blocks_bakery")}
                            value={props.attributes.title_size}
                            options={[
                                { label: 'Default', value: 30 },
                                { label: 'Small', value: 15 },
                                { label: 'Medium', value: 19 },
                                { label: 'Large', value: 29 },
                                { label: 'XL', value: 39 },
                                { label: 'XXL', value: 59 },
                            ]}
                            onChange={(new_val) => {
                                props.setAttributes({ title_size: new_val })
                            }} />
                        <PanelRow>
                            <h2>Heading</h2>
                        </PanelRow>
                        <SelectControl
                            label={__("HTML Tag", "blocks_bakery")}
                            value={props.attributes.heading}
                            options={[
                                { label: 'h1', value: 'h1' },
                                { label: 'h2', value: 'h2' },
                                { label: 'h3', value: 'h3' },
                                { label: 'h4', value: 'h4' },
                                { label: 'h5', value: 'h5' },
                                { label: 'h6', value: 'h6' },
                                { label: 'div', value: 'div' },
                                { label: 'span', value: 'span' },
                                { label: 'p', value: 'p' },
                            ]}
                            onChange={(new_val) => {
                                props.setAttributes({ heading: new_val })
                            }} />
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <p>Alignment</p>

                            <div>
                                <Dashicon style={{ cursor: 'pointer' }} onClick={alignLeft} icon='editor-alignleft' />
                                <Dashicon style={{ cursor: 'pointer' }} onClick={alignCenter} icon='editor-aligncenter' />
                                <Dashicon style={{ cursor: 'pointer' }} onClick={alignRight} icon='editor-alignright' />
                                <Dashicon style={{ cursor: 'pointer' }} onClick={alignJustify} icon='editor-justify' />
                            </div>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <p>Responsive</p>
                            <div>
                                <Dashicon style={{ cursor: 'pointer' }} onClick={laptop} icon='laptop' />
                                <Dashicon style={{ cursor: 'pointer' }} onClick={tablet} icon='tablet' />
                                <Dashicon style={{ cursor: 'pointer' }} onClick={smartphone} icon='smartphone' />
                            </div>
                        </div>
                    </PanelBody>
                    <PanelBody title={__('Title Color', 'blocks-bakery')} initialOpen={false}>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <p> <span>Text Color</span>
                                <ColorIndicator
                                    style={{ backgroundColor: props.attributes.title_color }} />
                            </p>
                            <Dashicon icon="image-rotate" onClick={clearTitleColor} />
                        </div>
                        <ColorPalette
                            colors={color_palette_list}
                            clearable={false}
                            onChange={(new_val) => {
                                props.setAttributes({ title_color: new_val })
                            }}
                            value={props.attributes.title_color}
                        />
                        <RangeControl
                            label={__('Opacity', 'blocks-bakery')}
                            min={0}
                            max={1}
                            value={props.attributes.title_opacity}
                            step={0.01}
                            onChange={(new_val) => {
                                props.setAttributes({ title_opacity: new_val })
                                hexConverter(new_val)
                            }}
                        />
                        <hr />

                        <SelectControl
                            label="Text Transform"
                            options={[
                                { label: 'Default', value: '' },
                                { label: 'Uppercase', value: 'uppercase' },
                                { label: 'Lowercase', value: 'lowercase' },
                                { label: 'Capitalize', value: 'capitalize' },
                                { label: 'Normal', value: 'normal' },
                            ]}
                            value={props.attributes.text_transform}
                            onChange={(new_val) => {
                                props.setAttributes({ text_transform: new_val })
                            }}
                        />
                    </PanelBody>
                    <PanelBody title={__('Typography', 'blocks-bakery')} initialOpen={false}>
                        < SelectControl
                            label="Font Family"
                            options={all_font_families}
                            onChange={(new_val) => {
                                props.setAttributes({ title_family: new_val })
                            }}
                            value={props.attributes.title_family}
                        />
                        <SelectControl
                            label="Font Weight"
                            options={[
                                { label: '100', value: 100 },
                                { label: '200', value: 200 },
                                { label: '300', value: 300 },
                                { label: '400', value: 400 },
                                { label: '500', value: 500 },
                                { label: '600', value: 600 },
                                { label: '700', value: 700 },
                                { label: '800', value: 800 },
                                { label: '900', value: 900 },
                                { label: 'Default', value: '' },
                                { label: 'Normal', value: 'normal' },
                                { label: 'Bold', value: 'bold' }
                            ]
                            }
                            onChange={(new_val) => {
                                props.setAttributes({ title_weight: new_val })
                            }}
                            value={props.attributes.title_weight}
                        />

                        <SelectControl
                            label="Blend Mode"
                            options={[
                                { label: 'Normal', value: 'normal' },
                                { label: 'Multiply', value: 'multiply' },
                                { label: 'Screen', value: 'screen' },
                                { label: 'Overlay', value: 'overlay' },
                                { label: 'Darken', value: 'darken' },
                                { label: 'Lighten', value: 'lighten' },
                                { label: 'Color Dodge', value: 'color-dodge' },
                                { label: 'Color Burn', value: 'color-burn' },
                                { label: 'Hard Light', value: 'hard-light' },
                                { label: 'Soft Light', value: 'soft-light' },
                                { label: 'Difference', value: 'difference' },
                                { label: 'Exclusion', value: 'exclusion' },
                                { label: 'HUE', value: 'hue' },
                                { label: 'Saturation', value: 'saturation' },
                                { label: 'Color', value: 'color' },
                                { label: 'Luminosity', value: 'luminosity' },
                            ]}
                            value={props.attributes.blend_mode}
                            onChange={(new_val) => {
                                props.setAttributes({ blend_mode: new_val })
                            }}
                        />

                        <SelectControl
                            label="Decoration"
                            options={[
                                { label: 'Default', value: 'inherit' },
                                { label: 'Underline', value: 'underline' },
                                { label: 'line Through', value: 'line-through' },
                                { label: 'Line Trough and Underline', value: 'underline line-through' },
                                { label: 'overline', value: 'overline' },
                                { label: 'None', value: 'none' },

                            ]}
                            value={props.attributes.text_decoration}
                            onChange={(new_val) => {
                                props.setAttributes({ text_decoration: new_val })
                            }}
                        />
                        <SelectControl
                            label="Style"
                            options={[
                                { label: 'Default', value: 'none' },
                                { label: 'Normal', value: 'normal' },
                                { label: 'Italic', value: 'italic' },
                                { label: 'Oblique', value: 'oblique' },
                            ]}
                            value={props.attributes.font_style}
                            onChange={(new_val) => {
                                props.setAttributes({ font_style: new_val })
                            }}
                        />

                        <PanelRow>
                            <p>Typography</p>

                            <div>
                                <Button id="px_case" onClick={px_case} style={{ textDecoration: "underline", padding: 0, boxShadow: "none", textTransform: "uppercase", fontSize: 10, marginRight: 5 }}>px</Button>
                                <Button id="em_case" onClick={em_case} style={{ padding: 0, boxShadow: "none", textTransform: "uppercase", fontSize: 10, marginRight: 5 }}>em</Button>
                                <Button id="rem_case" onClick={rem_case} style={{ padding: 0, boxShadow: "none", textTransform: "uppercase", fontSize: 10, marginRight: 5 }}>rem</Button>
                                <Button id="vw_case" onClick={vw_case} style={{ padding: 0, boxShadow: "none", textTransform: "uppercase", fontSize: 10, marginRight: 5 }}>vw</Button>
                            </div>
                        </PanelRow>
                        <RangeControl
                            label="Title Font Size"
                            min={0}
                            max={props.attributes.font_range_controller}
                            step={1}
                            initialPosition={26}
                            value={props.attributes.title_size}
                            onChange={(new_val) => {
                                props.setAttributes({ title_size: new_val })
                            }}
                        />
                        <PanelRow>
                            <p>Typography</p>

                            <div>
                                <Button id="title_px_lineh" onClick={title_px_lineh} style={{ textDecoration: "none", padding: 0, boxShadow: "none", textTransform: "uppercase", fontSize: 10, marginRight: 5 }}>px</Button>
                                <Button id="title_em_lineh" onClick={title_em_lineh} style={{ padding: 0, boxShadow: "underline", textTransform: "uppercase", fontSize: 10, marginRight: 5 }}>em</Button>
                            </div>
                        </PanelRow>
                        <RangeControl
                            label="Title Line Height "
                            min={0}
                            max={props.attributes.line_range_controller}
                            step={0.1}
                            initialPosition={1.5}
                            value={props.attributes.title_height}
                            onChange={(new_val) => {
                                props.setAttributes({ title_height: new_val })
                            }}
                        />
                        <RangeControl
                            label="Letter Spacing (px)"
                            min={0}
                            max={10}
                            step={0.1}
                            initialPosition={0}
                            value={props.attributes.letter_spacing_title}
                            onChange={(new_val) => {
                                props.setAttributes({ letter_spacing_title: new_val })
                            }}
                        />


                        <PanelRow>
                            <p>Text Shadow</p>
                            <div>
                                <Button onClick={title_reset} style={{ paddingLeft: 7, paddingRight: 7 }}><span><Dashicon icon="image-rotate" style={{ fontSize: 15 }} /></span></Button>
                                <Button onClick={title_toggle} style={{ paddingLeft: 7, paddingRight: 7 }}><span><Dashicon icon="admin-tools" style={{ fontSize: 15 }} /></span></Button>
                            </div>
                        </PanelRow>
                        <Card id="prifex-toggle" style={{ display: "none" }}>
                            <CardBody style={{ paddingTop: 16, paddingBottom: 16, paddingLeft: 10, paddingRight: 10 }}>

                                <RangeControl
                                    label="Blur"
                                    min={0}
                                    max={100}
                                    step={0.1}
                                    initialPosition={10}
                                    value={props.attributes.title_shadow_blur}
                                    onChange={(new_val) => {
                                        props.setAttributes({ title_shadow_blur: new_val })
                                        console.log("Bur")
                                    }}
                                />
                                <RangeControl
                                    label="horizontal"
                                    min={-100}
                                    max={100}
                                    step={0.1}
                                    initialPosition={0}
                                    value={props.attributes.text_shadow_horizental}
                                    onChange={(new_val) => {
                                        props.setAttributes({ text_shadow_horizental: new_val })
                                        console.log("horitzental")
                                    }}
                                />

                                <RangeControl
                                    label="Vertical"
                                    min={-100}
                                    max={100}
                                    step={0.1}
                                    initialPosition={0}
                                    value={props.attributes.text_shadow_vertical}
                                    onChange={(new_val) => {
                                        props.setAttributes({ text_shadow_vertical: new_val })
                                        console.log("vertical")
                                    }}
                                />

                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <p> <span>Text Shadow Color</span>
                                        <ColorIndicator
                                            style={{ backgroundColor: props.attributes.text_shadow_clor }} />
                                    </p>
                                    <Dashicon icon="image-rotate" onClick={clearTitleShadowColor} />
                                </div>
                                <ColorPalette
                                    clearable={false}
                                    colors={color_palette_list}
                                    onChange={(new_val) => {
                                        props.setAttributes({ text_shadow_clor: new_val })

                                    }}
                                    value={props.attributes.text_shadow_clor}
                                />
                            </CardBody>
                        </Card>

                    </PanelBody>
                </InspectorControls>

                <div className="bb-heading-main" style={styles.heading_container}>
                    <a className="bb-heading-link" style={styles.heading_link} href={props.attributes.title_link} target={props.attributes.open_tab} rel={props.attributes.rel_nofollow} >
                        <RichText
                            className={`bb-heading-content font-size`}
                            tagName={props.attributes.heading}
                            value={props.attributes.content_heading}
                            onChange={(new_val) => {
                                props.setAttributes({ content_heading: new_val })
                            }}
                            placeholder={__('Add Your Heading Text Here', 'blocks-bakery')}
                            style={styles.title_link}
                        />
                    </a>
                </div>
            </React.Fragment>
        )
    },

    save: (props) => {
        return (null)
    }
})